import { render, staticRenderFns } from "./ModalConfirmation.vue?vue&type=template&id=e00ccdf2&scoped=true&"
import script from "./ModalConfirmation.vue?vue&type=script&lang=js&"
export * from "./ModalConfirmation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e00ccdf2",
  null
  
)

export default component.exports